class AtendimentoDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.bindOverlay();
    this.bindTriggers();
  }

  bindOverlay() {
    const overlay = this.querySelector('#AtendimentoDrawer-Overlay');
    if (overlay) {
      overlay.addEventListener('click', this.close.bind(this));
    }
  }

  bindTriggers() {
    document.querySelectorAll('[data-atendimento-drawer-trigger]').forEach((trigger) => {
      trigger.setAttribute('role', 'button');
      trigger.setAttribute('aria-haspopup', 'dialog');

      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(trigger);
      });

      trigger.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(trigger);
        }
      });
    });
  }

  closeMobileMenu(triggeredBy) {
    const headerDrawer = triggeredBy?.closest('header-drawer');
    if (!headerDrawer?.mainDetailsToggle?.hasAttribute('open')) return;

    const summary = headerDrawer.querySelector('#Details-menu-drawer-container summary');
    headerDrawer.closeMenuDrawer(new Event('click'), summary);
  }

  open(triggeredBy) {
    if (triggeredBy) {
      this.activeElement = triggeredBy;
      this.closeMobileMenu(triggeredBy);
    }

    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = document.getElementById('AtendimentoDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('atendimento-drawer', AtendimentoDrawer);
